var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_2008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.76841 4.16555C6.76818 4.60758 6.59034 5.03141 6.274 5.34382C5.95767 5.65622 5.52875 5.8316 5.0816 5.83138C4.63446 5.83116 4.20572 5.65535 3.88969 5.34264C3.57367 5.02992 3.39626 4.60591 3.39648 4.16388C3.39671 3.72185 3.57455 3.29802 3.89089 2.98561C4.20722 2.67321 4.63614 2.49783 5.08329 2.49805C5.53043 2.49827 5.95917 2.67407 6.2752 2.98679C6.59122 3.29951 6.76863 3.72352 6.76841 4.16555ZM6.81898 7.06555H3.44706V17.4989H6.81898V7.06555ZM12.1466 7.06555H8.79156V17.4989H12.1129V12.0239C12.1129 8.97388 16.1339 8.69055 16.1339 12.0239V17.4989H19.4637V10.8905C19.4637 5.74888 13.5122 5.94055 12.1129 8.46555L12.1466 7.06555Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_2008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2315,
    height: 20,
    fill: "white",
    transform: "translate(0.917969)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.7be4f53aebec941c163caf27094dc5e3.svg";
export { ForwardRef as ReactComponent };